import { render, staticRenderFns } from "./ProfitLosses.vue?vue&type=template&id=596ad998&"
import script from "./ProfitLosses.vue?vue&type=script&lang=js&"
export * from "./ProfitLosses.vue?vue&type=script&lang=js&"
import style0 from "./ProfitLosses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports